/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { AlfaId } from './components/alfa-id';
import { ROUTER_STATUS } from './config';
import type { TFormAuthentication } from './models';
import { Control } from './components/control';
import { ACTION_TRIGGER } from './components/control/config';

export const FormAuthentication = ({
    Aligner,
    DEFAULT_VIEWS,
    FormNamedContainer,
    Grid,
    NamedContainer,
    analyticsAlfaId,
    authenticationType = 'otp',
    children,
    className,
    getNamedContainers,
    phoneSectionButtonWrapper,
}: TFormAuthentication) => {
    const {
        /** Экран подтверждения кода
         * Секция под виджетом Confirmation
         */
        codeSectionBottom = DEFAULT_VIEWS.codeSectionBottom,
        /** Экран подтверждения кода
         * Confirmation
         */
        codeSectionConfirmation = DEFAULT_VIEWS.codeSectionConfirmation,
        /** Экран подтверждения кода
         * Секция над виджетом Confirmation
         */
        codeSectionTop,
        /** Экран ошибки "Срок жизни кода истек" */
        confirmationCodeExpiredError = DEFAULT_VIEWS.confirmationCodeExpiredError,
        /** Экран ошибки "Ошибки на стороне SignOnline при верификации кода" */
        confirmationSingOnlineError = DEFAULT_VIEWS.confirmationSingOnlineError,
        /** Экран ввода номера телефона
         * Секция под кнопкой перехода на следующий экран
         */
        phoneSectionBottom,
        /** Экран ввода номера телефона
         * Кнопка перехода к следующему экрану (Триггер запроса кода)
         */
        phoneSectionButton = DEFAULT_VIEWS.phoneSectionButton,
        /** Экран ввода номера телефона
         * Секция над кнопкой перехода на следующий экран
         */
        phoneSectionTop,
        /** Экран ошибки "Ошибки на стороне SignOnline при запросе кода" */
        requestCodeSignOnlineError = DEFAULT_VIEWS.requestCodeSignOnlineError,
        /** Экран ошибки "Ошибка сессии" */
        sessionTimeExpired = DEFAULT_VIEWS.sessionTimeExpired,
        /** Экран ошибки "Внутренняя ошибка сервиса" */
        technicalError = DEFAULT_VIEWS.technicalError,
        /** Экран ошибки "Количество попыток исчерпано" */
        tooMuchCodeVerification = DEFAULT_VIEWS.tooMuchCodeVerification,
        /** Экран ошибки "Ошибка валидации" */
        validationError = DEFAULT_VIEWS.validationError,
        /** Дефолтный экран при аутентификации через AlfaId" */
        alfaId = DEFAULT_VIEWS.alfaId,
    } = getNamedContainers(children);

    return (
        <div className={className}>
            {authenticationType === 'otp' ? (
                /** Собираем стандартный флоу аутентификации с вводом номера телефона через NamedContainer */
                <FormNamedContainer name="authenticationStatus">
                    <NamedContainer name="processing">
                        <FormNamedContainer name="authenticationStep">
                            <NamedContainer name="enterPhoneNumber">
                                {phoneSectionTop}
                                <Aligner align="left">
                                    <Grid {...phoneSectionButtonWrapper}>
                                        <Control
                                            action={ROUTER_STATUS.REQUEST_CODE}
                                            loading="buttonLoading"
                                        >
                                            {phoneSectionButton}
                                        </Control>
                                    </Grid>
                                </Aligner>
                                {phoneSectionBottom}
                            </NamedContainer>
                            <NamedContainer name="checkConfirmationCode">
                                {codeSectionTop}
                                <Control
                                    action={ROUTER_STATUS.CONFIRM_CODE}
                                    trigger={[
                                        ACTION_TRIGGER.ONINPUTFINISHED,
                                        ACTION_TRIGGER.ONSMSRETRYCLICK,
                                    ]}
                                >
                                    {codeSectionConfirmation}
                                </Control>
                                <Grid alignment="center" colAutoWidth collapse justify="center">
                                    <Control action={ROUTER_STATUS.START}>
                                        {codeSectionBottom}
                                    </Control>
                                </Grid>
                            </NamedContainer>
                        </FormNamedContainer>
                    </NamedContainer>
                    <NamedContainer name="error">
                        <FormNamedContainer name="errorStatus">
                            <NamedContainer name="validationError">
                                <Control action={ROUTER_STATUS.START}>{validationError}</Control>
                            </NamedContainer>
                            <NamedContainer name="tooMuchCodeVerification">
                                <Control action={ROUTER_STATUS.START}>
                                    {tooMuchCodeVerification}
                                </Control>
                            </NamedContainer>
                            <NamedContainer name="requestCodeSignOnlineError">
                                <Control action={ROUTER_STATUS.REQUEST_CODE} loading="showLoader">
                                    {requestCodeSignOnlineError}
                                </Control>
                            </NamedContainer>
                            <NamedContainer name="confirmationSingOnlineError">
                                <Control
                                    action={ROUTER_STATUS.REQUEST_VERIFY_PHONE_CODE}
                                    loading="showLoader"
                                >
                                    {confirmationSingOnlineError}
                                </Control>
                            </NamedContainer>
                            <NamedContainer name="confirmationCodeExpiredError">
                                <Control
                                    action={ROUTER_STATUS.REQUEST_VERIFY_PHONE_CODE}
                                    loading="showLoader"
                                >
                                    {confirmationCodeExpiredError}
                                </Control>
                            </NamedContainer>
                            <NamedContainer name="sessionTimeExpired">
                                <Control action={ROUTER_STATUS.START}>{sessionTimeExpired}</Control>
                            </NamedContainer>
                            <NamedContainer name="technicalError">
                                <Control action={ROUTER_STATUS.START}>{technicalError}</Control>
                            </NamedContainer>
                        </FormNamedContainer>
                    </NamedContainer>
                </FormNamedContainer>
            ) : (
                <AlfaId analytics={analyticsAlfaId}>{alfaId}</AlfaId>
            )}
        </div>
    );
};
